module.exports = __webpack_public_path__ + "static/media/q5.927f4ac0.png";